export const REQUEST_GET_PROVISIONAL_CLAIM_DETAILS =
  'REQUEST_GET_PROVISIONAL_CLAIM_DETAILS';
export const REQUEST_SET_PROVISIONAL_CLAIM_DETAILS =
  'REQUEST_SET_PROVISIONAL_CLAIM_DETAILS';
export const REQUEST_CREATE_MISSION = 'REQUEST_CREATE_MISSION';
export const RESET_PROVISIONAL_CLAIM_DETAILS_STORE =
  'RESET_PROVISIONAL_CLAIM_DETAILS_STORE';
export const SET_PROVISIONAL_CLAIM_REFERENCE =
  'SET_PROVISIONAL_CLAIM_REFERENCE';
export const REQUEST_UPDATE_CLAIM_NUMBER = 'REQUEST_UPDATE_CLAIM_NUMBER';
export const SET_UPDATE_CLAIM_NUMBER_RESULT = 'SET_UPDATE_CLAIM_NUMBER_RESULT';
export const REQUEST_VALIDATE_PROVISIONAL_LIAISON =
  'REQUEST_VALIDATE_PROVISIONAL_LIAISON';
export const REQUEST_REJECT_PROVISIONAL_LIAISON =
  'REQUEST_REJECT_PROVISIONAL_LIAISON';
